"use strict";
/**
 * Public types for the physics engine.
 *
 * Units at this boundary match the rest of the package: meters, seconds,
 * degrees, physics coordinates (origin at the venue's center, +x right, +y toward
 * the far baseline, +z up). Ball spin is in ball RPM.
 *
 * Everything here is plain, immutable data. The engine never mutates what it
 * is given and keeps no state between calls.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NO_SPIN = void 0;
exports.NO_SPIN = Object.freeze({ rpm: 0, axis: 0 });
